module.exports = __webpack_public_path__ + "img/testequipment-min.60d7a17b.jpg";